import { render, staticRenderFns } from "./insurranceEditor.vue?vue&type=template&id=b2977854"
import script from "./insurranceEditor.vue?vue&type=script&lang=js"
export * from "./insurranceEditor.vue?vue&type=script&lang=js"
import style0 from "./insurranceEditor.vue?vue&type=style&index=0&id=b2977854&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports